import axios from 'axios';
import { ADMINISTRATION_SERVICE_URL, BACKEND_URL, PAYMENT_SERVICE_URL } from '../../../constants/rest-api-constants';

const backendHttpClient = axios.create({
  baseURL: BACKEND_URL + '/api',
});

export const paymentHttpClient = axios.create({
  baseURL: PAYMENT_SERVICE_URL + '/api',
});

export const administrationHttpClient = axios.create({
  baseURL: ADMINISTRATION_SERVICE_URL + '/api',
});

export default backendHttpClient;
